import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Achievement = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2020 - 2021</p>
          <h2 className="text-3xl md:text-4xl font-bold">Organisational Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full  border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Himpunan Mahasiswa Teknik Informatika (HMTI)"
            subTitle="IPTEK Division – A3"
            result="UDINUS"
            des={
            <>
              <ul>
                <li>- Mengikuti pelatihan hardskill dan softskill oleh HMTI</li>
                <li>- Mengikuti webinar dan talk session oleh HMTI</li>
                <li>- Menjadi Panitia SEMNASTI Event Committee 2021 –
                Sie Dekorasi dan Dokumentasi</li>
                
              </ul>
            </>
            }
          />
         
        </div>
      </div>
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          
        </div>
        <div className="mt-6 lgl:mt-14 w-full  border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Brand Ambassador Maju Indonesia"
            subTitle="Maju Indonesia"
            result="Jakarta"
            des={
            <>
              <ul>
                <li>- Mengikuti pelatihan hardskill dan softskill oleh HMTI</li>
                <li>- Mengikuti webinar dan talk session oleh HMTI</li>
                <li>- Menjadi Panitia SEMNASTI Event Committee 2021 –
                Sie Dekorasi dan Dokumentasi</li>
                
              </ul>
            </>
            }
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Achievement;
